import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import RichTextEditor from "react-rte";
import { Button } from "reactstrap";
import moment from "moment";
import { API_END_POINT } from "../config";
const token = localStorage.getItem("token");
// import { DateRangePicker } from "react-dates";
// import "react-dates/initialize";

// import Select from "react-select";
// import "react-select/dist/react-select.css";

import CKEditor from "ckeditor4-react";

export default class BlogsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      blog: {
        title: "",
        image: "",
        blogText: "",
      },
      blogText: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.postBlog = this.postBlog.bind(this);

    // this.handleChange = this.handleChange.bind(this);
    this.onEditorChange = this.onEditorChange.bind(this);
  }

  componentDidMount() {
    const { match } = this.props;
    if (match.params.blogId) {
      axios
        .get(`${API_END_POINT}/api/blog/one/${match.params.blogId}`, {
          headers: { "auth-token": token },
        })
        .then((response) => {
          console.log("response", response.data.data);
          this.setState({
            blog: response.data.data,
            blogText: response.data.data.blogText,
          });
        });
    }
  }

  onEditorChange(evt) {
    // var blogText = this.state.blog.blogText;
    this.setState({
      blogText: evt.editor.getData(),
    });
    console.log(this.state);
  }

  handleInputChange(event) {
    const { value, name } = event.target;

    const { blog } = this.state;
    blog[name] = value;
    this.setState({ blog });
  }

  // handleImages = (event) => {
  //   this.setState({ blog: event.target.files[0] });
  // }

  handleImages = (event) => {
    const { name } = event.target;
    const { blog } = this.state;
    blog[name] = event.target.files[0];
    this.setState({ blog });
  };

  postBlog(event) {
    event.preventDefault();
    const { match } = this.props;
    const { blog, blogText } = this.state;
    this.setState({ loading: true });

    const fd = new FormData();
    // Object.keys(blog).forEach((eachState) => {
    //   fd.append(`${eachState}`, blog[eachState]);
    // });

    fd.append("title", blog.title);
    fd.append("image", blog.image);
    fd.append("blogText", blogText);
    fd.append("date", moment().format());

    if (match.params.blogId) {
      let blogCopy = { ...blog };
      blogCopy.blogId = blogCopy._id;
      delete blogCopy["_id"];
      delete blogCopy["date"];
      delete blogCopy["__v"];
      delete blogCopy["blogText"];
      this.setState({ blog: blogCopy });
      const fd = new FormData();
      Object.keys(blogCopy).forEach((eachState) => {
        fd.append(`${eachState}`, blogCopy[eachState]);
      });
      fd.append("blogText", blogText);
      fd.append("date", moment().format());
      // fd.append("blogId", blog.blogId);
      axios
        .put(`${API_END_POINT}/api/blog/update`, fd, {
          headers: { "auth-token": token },
        })
        .then((response) => {
          if (response.status === 200) {
            window.alert(response.data.message);
            this.setState({ loading: false });
            this.props.history.goBack();
          } else {
            window.alert("ERROR");
            this.setState({ loading: false });
          }
        });
    } else {
      axios
        .post(`${API_END_POINT}/api/blog`, fd, {
          headers: { "auth-token": token },
        })
        .then((response) => {
          if (response.status === 200) {
            window.alert(response.data.message);
            this.setState({ loading: false });
            this.props.history.goBack();
          } else {
            window.alert("ERROR");
            this.setState({ loading: false });
          }
        });
    }
  }

  render() {
    const { loading, blog, blogText } = this.state;
    const toolbarConfig = {
      // Optionally specify the groups to display (displayed in the order listed).
      display: [
        "INLINE_STYLE_BUTTONS",
        "BLOCK_TYPE_BUTTONS",
        "HISTORY_BUTTONS",
        "BLOCK_TYPE_DROPDOWN",
      ],
      INLINE_STYLE_BUTTONS: [
        {
          label: "Bold",
          style: "BOLD",
          className: "custom-css-class",
        },
        {
          label: "Italic",
          style: "ITALIC",
        },
        {
          label: "Underline",
          style: "UNDERLINE",
        },
      ],
      BLOCK_TYPE_DROPDOWN: [
        {
          label: "Normal",
          style: "unstyled",
        },
        {
          label: "Large Heading",
          style: "header-three",
        },
        {
          label: "Medium Heading",
          style: "header-four",
        },
        {
          label: "Small Heading",
          style: "header-five",
        },
      ],
      BLOCK_TYPE_BUTTONS: [
        {
          label: "UL",
          style: "unordered-list-item",
        },
        {
          label: "OL",
          style: "ordered-list-item",
        },
      ],
    };
    return (
      <div className="row animated fadeIn">
        <div className="col-12">
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="x_panel">
                <div className="x_title">
                  <h2>Blogbeitrag anlegen:</h2>
                </div>
                <div className="x_content">
                  <br />
                  <form
                    id="demo-form2"
                    data-parsley-validate
                    className="form-horizontal form-label-left"
                    onSubmit={this.postBlog}
                  >
                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Titel
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="title"
                          className="form-control"
                          value={blog.title}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Bild
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          type="file"
                          accept="image/*"
                          name="image"
                          className="form-control"
                          onChange={this.handleImages}
                          // multiple
                          required={
                            this.props.match.params.blogId ? false : true
                          }
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Blog Text
                      </label>
                      {/* <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="blogText"
                          className="form-control"
                          value={blog.blogText}
                          onChange={this.handleInputChange}
                        />
                      </div> */}
                      <CKEditor
                        onChange={this.onEditorChange}
                        data={blogText}
                      />
                    </div>

                    <div className="ln_solid" />
                    <div className="form-group row">
                      <div className="col-md-6 col-sm-6 offset-md-3">
                        <Button
                          className={`btn btn-success btn-lg ${
                            this.state.loading ? "disabled" : ""
                          }`}
                        >
                          <i
                            className={`fa fa-spinner fa-pulse ${
                              this.state.loading ? "" : "d-none"
                            }`}
                          />{" "}
                          Bestätigen
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/BlogsForm.jsx